import styled from "@emotion/styled"
import { Button, Typography } from "@mui/material"
import { FineDetailsPublicResponse } from "api"
import { useTranslations } from "next-intl"
import Image from "next/image"
import { Link } from "utils"

const SuccessBox = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
  text-align: center;
`

const SuccessTextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const DetailsBox = styled.div`
  display: flex;
  padding: 16px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 24px 24px 32px 24px;
  }
  flex-direction: column;
  gap: 32px;
  border-radius: 12px;
  border: 1px solid #d1d5db;

  box-shadow: 0px 2px 8px 0px rgba(38, 48, 61, 0.16);
`

const DetailsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 32px;
  }
`

const DetailsGrid = styled.div<{ isPayerDetails?: boolean }>`
  display: grid;
  grid-template-columns: ${({ isPayerDetails }) =>
    isPayerDetails ? "1fr 1fr" : "1fr"};
  padding-bottom: 32px;
  gap: 32px;
  border-bottom: ${({ isPayerDetails }) =>
    isPayerDetails ? "none" : "1px solid var(--Grey-Gray-M, #d1d5db)"};
  ${({ theme }) => theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 24px;
  }
`

const ButtonFlex = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  ${({ theme }) => theme.breakpoints.up("md")} {
    align-self: center;
    gap: 24px;
    flex-direction: row;
    width: 100%;
    max-width: 528px;
  }
`

const DetailGridItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export default function Success({
  data,
  iframeData,
}: {
  data: FineDetailsPublicResponse
  iframeData: {
    confirmationNumber: string
    email: string
    firstname: string
    lastname: string
    cardholderid: string
    pdf: string
    phone: string
  }
}) {
  const t = useTranslations("Forms")
  const pdf = {
    file: `data:application/pdf;base64,${iframeData.pdf}`,
    file_name: "Purchase Invoice",
  }
  const handleDownload = () => {
    const pdfLink = `${pdf.file}`
    const anchorElement = document.createElement("a")
    const fileName = `${pdf.file_name}.pdf`
    anchorElement.href = pdfLink
    anchorElement.download = fileName
    anchorElement.click()
  }
  const decodedFirstname = document.createElement("textarea")
  decodedFirstname.innerHTML = iframeData.pdf
  console.log(decodedFirstname.value, "checkthis")
  return (
    <>
      <SuccessBox>
        <Image
          src={"/icons/formSuccess.gif"}
          width={200}
          height={200}
          alt="success"
        />
        <SuccessTextBox>
          <Typography variant="h3">{t("paymentReceived")}</Typography>
          <Typography variant="body1">{t("sentPayment")}</Typography>
        </SuccessTextBox>
      </SuccessBox>
      <DetailsBox>
        <DetailsContent>
          <Typography variant="h4">{t("paymentDetails")}</Typography>
          <DetailsGrid>
            <DetailGridItem>
              <Typography variant="body1" fontWeight={700}>
                {t("referenceNum")}
              </Typography>
              <Typography variant="body1">
                {iframeData.confirmationNumber}
              </Typography>
            </DetailGridItem>
            <DetailGridItem>
              <Typography variant="body1" fontWeight={700}>
                {t("amountPaid")}
              </Typography>
              <Typography variant="body1">₪{data.fineAmount}</Typography>
            </DetailGridItem>
            <DetailGridItem>
              <Typography variant="body1" fontWeight={700}>
                {t("reportNumber")}
              </Typography>
              <Typography variant="body1">{data.fineId}</Typography>
            </DetailGridItem>
            <DetailGridItem>
              <Typography variant="body1" fontWeight={700}>
                {t("formNumber")}
              </Typography>
              <Typography variant="body1">{data.fineNumerator}</Typography>
            </DetailGridItem>
          </DetailsGrid>
        </DetailsContent>
        <DetailsContent>
          <Typography variant="h4">{t("payerDetails")}</Typography>
          <DetailsGrid isPayerDetails>
            <DetailGridItem>
              <Typography variant="body1" fontWeight={700}>
                {t("firstName")}
              </Typography>
              <Typography variant="body1">{iframeData.firstname}</Typography>
            </DetailGridItem>
            <DetailGridItem>
              <Typography variant="body1" fontWeight={700}>
                {t("lastName")}
              </Typography>
              <Typography variant="body1">{iframeData.lastname}</Typography>
            </DetailGridItem>
            <DetailGridItem>
              <Typography variant="body1" fontWeight={700}>
                {t("idCard")}
              </Typography>
              <Typography variant="body1">{iframeData.cardholderid}</Typography>
            </DetailGridItem>
            <DetailGridItem>
              <Typography variant="body1" fontWeight={700}>
                {t("phone1")}
              </Typography>
              <Typography variant="body1">{iframeData.phone}</Typography>
            </DetailGridItem>
          </DetailsGrid>
        </DetailsContent>
      </DetailsBox>
      <ButtonFlex>
        <Button variant="primary" fullWidth onClick={handleDownload}>
          {t("downloadPayment")}
        </Button>
        <Button variant="secondary" fullWidth LinkComponent={Link} href="/">
          {t("backToHomepage")}
        </Button>
      </ButtonFlex>
    </>
  )
}
